import * as React from 'react';
import ReactSelect from 'react-select';
import { useTranslator } from '@gandi/translate';
import { useReadonly, usePortal } from '../../hooks';
import * as theme from '../theme';
import { jsx as _jsx } from "react/jsx-runtime";
function Select({
  variant = 'default',
  isReadonly,
  ...extraProps
}, ref) {
  const {
    __
  } = useTranslator();
  const readOnlyProps = useReadonly({
    isReadonly
  });
  const portalProps = usePortal();
  return (
    /*#__PURE__*/
    // $FlowFixMe[cannot-spread-inexact]
    _jsx(ReactSelect
    // This will return the component instance `SelectInstance<>`, not the DOM node.
    // Expected to be able to access certain methods, such as `ref.focus()`.
    , {
      ref: ref,
      uiVariant: variant,
      placeholder: __('Select...'),
      isReadonly: isReadonly,
      ...theme,
      ...readOnlyProps,
      ...portalProps,
      ...extraProps
    })
  );
}
const Export = /*#__PURE__*/React.forwardRef(Select);
Export.displayName = 'Select';
export { Export as Select };